import { render, staticRenderFns } from "./LCCreateLockerCompanyDialog.vue?vue&type=template&id=3bff98fe&"
import script from "./LCCreateLockerCompanyDialog.vue?vue&type=script&lang=ts&"
export * from "./LCCreateLockerCompanyDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports